module.exports = [["intro",[["main",3]]],["mythos",[["story",1],["characters",4],["locations",2]]],["diaryofanant",[["story",1],["characters",10],["locations",3]]],["wheels",[["story",1],["characters",6],["locations",8]]],["swimandgoseek",[["story",1],["characters",3],["locations",5]]],["thesuperlatives",[["story",1],["characters",6],["locations",1]]],["behindtheclosetdoor",[["story",1],["characters",3],["locations",2]]],["inoneearandouttheother",[["story",1],["characters",1],["locations",3]]]]


//////////////////
// WEBPACK FOOTER
// ./webpack/carousel/slide_manifest.json
// module id = ./webpack/carousel/slide_manifest.json
// module chunks = 0